var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"999"}},[_c('v-progress-circular',{staticClass:"center",attrs:{"indeterminate":"","size":"40"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }